import styled from 'styled-components';

import Button from '../../../../../atoms/nButton';

export const IconButton = styled(Button)`
  border: none;
  border-radius: 0;
  background: transparent;
`
